const configuratorLogger = (...args) => {
    console.log("[Player Customization]", ...args);
}

const playerMap = {
    1: "LEALI",
    3: "FRESE",
    4: "ZAPPA",
    5: "EDMUNDSSON",
    6: "BRADARIĆ",
    8: "SERDAR",
    9: "SARR",
    10: "SUSLOV",
    11: "COMPAGNON",
    12: "BORGHI",
    14: "LIVRAMENTO",
    17: "LE BORGNE",
    18: "L. BEGA",
    19: "MULATTIERI",
    20: "KASTANOS",
    21: "HARROUI",
    22: "TONIOLO",
    23: "LELLA",
    24: "BERNEDE",
    25: "D. MOSQUERA",
    27: "DAWIDOWICZ",
    28: "SLOTSAGER",
    33: "TAGNE",
    34: "PERILLI",
    35: "CERBONE",
    37: "CALABRESE",
    38: "AKALÈ",
    44: "IANNONI",
    48: "KORAĆ",
    70: "FALLOU",
    71: "DE BATTISTI",
    79: "SEZONIENKO",
    81: "EKUBAN",
    90: "VERMESAN"
};

const acceptedLetters = [
    "a", "b", "c", "d", "e", "f", "g", "h", "i", "j",
    "k", "l", "m", "n", "o", "p", "q", "r", "s", "t",
    "u", "v", "w", "x", "y", "z", " ", "'"];

const bannedWords = [
    "ZGlvY2FuZQ==", "ZGlvcG9yY28=", "cG9yY29kaW8=", "ZGlvYm9pYQ==", "ZGlvc3BvcmNv", "ZGlvbHVyaWRv", "Ym9pYWRpbw==",
    "ZGlvIGNhbmU=", "ZGlvIHBvcmNv", "cG9yY28gZGlv", "ZGlvIGJvaWE=", "ZGlvIHNwb3Jjbw==", "ZGlvIGx1cmlkbw==", "Ym9pYSBkaW8=",
    "Y2F6em8=", "bWluaGNoaWE=", "dmFnaW5h", "c2NvcGFyZQ==", "c2NvcGFtaQ==", "c3VjY2hpYW1p", "bmVyY2hpYQ==",
    "c3VjYW1lbG8=", "cG9tcGlubw==", "c2Vzc28=", "Zm90dGVyZQ==", "Y2hpYXZhcmU=", "dHJvbWJhbWk=",
    "bWVyZGE=", "c3Ryb256bw==", "c3Ryb256YQ==", "YmFzdGFyZG8=", "YmFzdGFyZGE=", "dmFmZmFuY3Vsbw==", "ZmFuY3Vsbw==",
    "c3VjYQ==", "c3Vra2lhbWVsbw==", "c3RpY2F6emk=", "dHJvaWE=", "cHV0dGFuYQ==", "em9jY29sYQ==",
    "bWlnbm90dGE=", "YmF0dG9uYQ==", "bHVyaWRh", "bHVyaWRv", "aW5mYW1l", "c2NlbW8=", "c2NlbWE=",
    "aWRpb3Rh", "Y3JldGlubw==", "Y29nbGlvbmU=", "Y29nbGlvbmE=", "aW1iZWNpbGxl", "bW9uZ29sb2lkZQ==",
    "c3Bhc3RpY28=", "aGFuZGljYXA=", "bmVncm8=", "bmVncmFjY2lv", "emluZ2Fybw==", "ZnJvY2lv",
    "cmljY2hpb25l", "Y3VsYXR0b25l", "bGVzYmljYQ==", "dGVycm9uZQ==", "dGVydW4=", "cG9sZW50b25l",
    "ZnVjaw==", "c2hpdA==", "Yml0Y2g=", "YmFzdGFyZA==", "YXNzaG9sZQ==", "ZGljaw==", "cHVzc3k=", "ZnVja2Vy",
    "d2hvcmU=", "c2x1dA==", "cmV0YXJk", "Y3JpcHBsZQ==", "bmlnZ2Vy", "amVyaw==", "c3Vja2l0",
    "bmlrZQ==", "YWRpZGFz", "Z3VjY2k=", "ZmJp", "YXBwbGU=", "Z29vZ2xl", "ZmFjZWJvb2s=", "dGlrdG9r", "c2Ftc3VuZw==", "cGVwc2k=", "Y29jYWNvbGE="
].map(word => atob(word));

document.addEventListener("DOMContentLoaded", () => {
    console.log("DOM fully loaded and parsed");
    const personalizeContainer = document.querySelector(".product-personalizer");
    // listen for changes in the personalize container to update the button label as soon as it is added to the DOM
    console.log("Personalize container:", personalizeContainer);
    readyOnce(".product-personalizer .pplr-c-button.pplr-btn.button.Button--secondary.ptc_button", (button) => {
        console.log("Personalize button found:", button);
        button.textContent = window.configuratorLabels.label_bottone_personalizza;
    });

    const containerVariants = document.querySelector(".product-info__block-list");
    const isCustomizable = isConfigurableProduct();
    if (containerVariants && isCustomizable) {
        containerVariants?.addEventListener("click", () => {
            addConfigurableClassToAddToCartButton();
        });
    }

    removeCustomizationAppStyles();


    personalizeContainer?.addEventListener("click", (e) => {
        if (e.target.tagName === "BUTTON" || e.target.closest("button")) {            
            // const personalizationButton = e.target.tagName === "BUTTON" ? e.target : e.target.closest("button");

            const playerButton = document.querySelector(".cstmfy_personalize_text ._pplr_player");
            const playerCustomButton = document.querySelector(".cstmfy_personalize_text ._pplr_name-number");
            const shortsNumberButton = document.querySelector(".cstmfy_personalize_text ._pplr_shorts-number");

            replaceLabelConfigurator(); // Problema
            blockMiniatureClick();
            showPersonalizationDisclaimer();

            if (e.target.closest("button").classList.contains("pplr_remove")) {
                console.log("The player button has the pplr_remove class");
                updatePersonalizationFields("", "", true);
                unblockMiniatureClick();
                hidePersonalizationDisclaimer();
                
                const configuratoreActiveItem = document.querySelector("span.pplr-drop-item.active");
                if (configuratoreActiveItem) {
                    configuratoreActiveItem.click();
                }
            }

            playerButton?.addEventListener("click", () => {                
                if (playerButton.classList.contains("active")) {
                    replaceLabelConfigurator();
                    const selectedPlayer = document.querySelector(".pplr-player select");
                    selectedPlayer?.addEventListener("change", () => {
                        updatePlayerPrintableInfo();
                    });

                    document.querySelector(".pplr-name").classList.remove("show-inputs");
                    document.querySelector(".pplr-number").classList.remove("show-inputs");

                    configuratorLogger("The player button has the active class!!");
                    updatePlayerPrintableInfo();
                } else {
                    console.log("The player button does not have the active class");
                }
            });

            playerCustomButton?.addEventListener("click", () => {
                if (playerCustomButton.classList.contains("active")) {
                    replaceLabelConfigurator();

                    const numberField = document.querySelector(".pplr-number input");
                    numberField?.addEventListener("input", () => {
                        const sanitizedInput = sanitizePlayerInput(numberField.value, "number");
                        numberField.value = sanitizedInput;
                        displayPlayerNumber();
                    });

                    const nameField = document.querySelector(".pplr-name input");
                    nameField?.addEventListener("input", () => {
                        const sanitizedInput = sanitizePlayerInput(nameField.value, "name");
                        nameField.value = sanitizedInput.toUpperCase();
                        displayPlayerLetters();
                    });


                    console.log("The player custom button has the active class!!");
                    document.querySelector(".pplr-name").classList.add("show-inputs");
                    document.querySelector(".pplr-number").classList.add("show-inputs");
                    updatePersonalizationFields("", "", true);
                } else {
                    console.log("The player button does not have the active class");
                }
            });

            shortsNumberButton?.addEventListener("click", () => {
                if (shortsNumberButton.classList.contains("active")) {
                    replaceLabelConfigurator();
                    const numberField = document.querySelector(".pplr-number input");
                    numberField?.addEventListener("input", () => {
                        const sanitizedInput = sanitizePlayerInput(numberField.value, "number");
                        numberField.value = sanitizedInput;
                        displayPlayerNumber();
                    });


                    console.log("The shorts number button has the active class!!");
                    document.querySelector(".pplr-number").classList.add("show-inputs");
                    updatePersonalizationFields("", "", true);
                } else {
                    console.log("The shorts number button does not have the active class");
                }
            });
        }
    });
});

function updatePlayerPrintableInfo() {
    const selectedPlayer = document.querySelector(".pplr-player select").value || "";
    const [playerNumber, playerName] = getPlayerInfos(selectedPlayer);
    console.log("Selected player Number:", playerNumber);
    console.log("Selected player Name:", playerName);
    updatePersonalizationFields(playerNumber, playerName);
}

function getPlayerInfos(playerInfo) {
    if (playerInfo) {
        const parts = playerInfo.split("-").map((part) => part.trim());
        console.log("Player info parts:", parts);
        const playerNumber = parts[0];

        //Gestione casista speciale per McFRATM dove il numero viene usato per due giocatori nella maglia junior
        if (parts[1].toLowerCase() == "mcfratm") {
            return [playerNumber, "McFRATM"];
        }

        const playerName = getPlayerNameFromNumber(playerNumber);
        return [playerNumber, playerName];
    }
}

function getPlayerNameFromNumber(playerNumber) {
    return playerMap[playerNumber] || "";
}

function updatePersonalizationFields(playerNumber, playerName, clearFields = false) {
    const nameField = document.querySelector(".pplr-name input");
    const numberField = document.querySelector(".pplr-number input");
    const containerNumberPreview = document.querySelector(".player-number-images-container");
    const containerLetterPreview = document.querySelector(".player-letter-images-container");
    if (nameField && numberField) {
        if (clearFields) {
            containerNumberPreview?.remove();
            containerLetterPreview?.remove();
            nameField.value = "";
            numberField.value = "";
            console.log("Fields cleared");
        } else {
            nameField.value = playerName;
            numberField.value = playerNumber;
            displayPlayerLetters();
            displayPlayerNumber();
        }

        console.log("Name field updated:", nameField.value);
        console.log("Number field updated:", numberField.value);
    } else {
        console.log("Name or number field is missing");
    }
}

function displayPlayerNumber(shorts = false) {
    console.log("Player number changed");
    const numberField = document.querySelector(".pplr-number input");
    const playerNumber = numberField.value;
    const firstTwoDigits = playerNumber.slice(0, 2);

    const mediaContainer = document.querySelector(".product-gallery__media.pplr");

    const containerClassName = shorts ? "shorts-number-images-container" : "player-number-images-container";

    if (mediaContainer) {
        // Rimozione di eventuali contenitori precedenti
        const existingContainer = mediaContainer.querySelector(`.${containerClassName}`);
        if (existingContainer) {
            existingContainer.remove();
        }

        // Creazione delle immagini dei numeri solo se firstTwoDigits ha contenuto
        if (firstTwoDigits && firstTwoDigits.trim() !== "") {
            const numberImagesContainer = document.createElement("div");
            numberImagesContainer.classList.add(containerClassName);

            // Creazione delle immagini dei numeri
            for (const digit of firstTwoDigits) {
                if (window.fontConfig && window.fontConfig.numbers && window.fontConfig.numbers[digit]) {
                    const imgElement = document.createElement("img");
                    imgElement.classList.add("player-number-image");
                    imgElement.src = window.fontConfig.numbers[digit];
                    imgElement.alt = `Number ${digit}`;
                    numberImagesContainer.appendChild(imgElement);
                } else {
                    console.warn(`Image for digit ${digit} not found in window.fontConfig.numbers`);
                }
            }

            // Aggiungiamo il contenitore
            mediaContainer.querySelector(".pplr_preview_wrapper").appendChild(numberImagesContainer);
            // mediaContainer.appendChild(numberImagesContainer);
            console.log("Player number images added to .product-gallery__media.pplr");
        }
    } else {
        console.warn(".product-gallery__media.pplr container not found for displaying player number.");
    }

    console.log("Player number for images:", firstTwoDigits);
}

function displayPlayerLetters() {
    console.log("Player letters changed");
    const nameField = document.querySelector(".pplr-name input");
    const playerName = nameField.value?.trim();
    const firstTenLetters = playerName.slice(0, 12);
    const letterMap = {
        " ": "_",
        "'": "__",
        ".": "___",
        "c": "c-",
        "É": "E_",
        "È": "E__",
        "Ø": "O___",
        "Ć": "C_",
        "Ò": "O__",


        // aggiungi altre mappature se necessario, ad esempio:
        // "à": "a", "è": "e"
    };

    const mappedLetters = Array.from(firstTenLetters).map(char => letterMap[char] || char);
    console.log("Mapped letters:", mappedLetters);

    const mediaContainer = document.querySelector(".product-gallery__media.pplr");

    if (mediaContainer) {
        // Rimozione di eventuali contenitori precedenti
        const existingContainer = mediaContainer.querySelector(".player-letter-images-container");
        if (existingContainer) {
            existingContainer.remove();
        }

        // Creazione delle immagini dei numeri
        if (mappedLetters && mappedLetters.length > 0) {
            const letterImagesContainer = document.createElement("div");
            letterImagesContainer.classList.add("player-letter-images-container");

            // Creazione delle immagini dei numeri
            for (const letter of mappedLetters) {
                if (window.fontConfig && window.fontConfig.letters && window.fontConfig.letters[letter]) {
                    const imgElement = document.createElement("img");
                    imgElement.classList.add("player-letter-image");
                    imgElement.src = window.fontConfig.letters[letter];
                    imgElement.alt = `Letter ${letter}`;
                    letterImagesContainer.appendChild(imgElement);
                } else {
                    console.warn(`Image for digit ${letter} not found in window.fontConfig.letter`);
                }
            }

            // Aggiungiamo il contenitore
            mediaContainer.querySelector(".pplr_preview_wrapper").appendChild(letterImagesContainer);
            // mediaContainer.appendChild(letterImagesContainer);
            console.log("Player letter images added to .product-gallery__media.pplr");
        }
    } else {
        console.warn(".product-gallery__media.pplr container not found for displaying player letter.");
    }

    console.log("Player letter for images:", firstTenLetters);
}

function sanitizePlayerInput(input, type) {
    if (type === "number") {
        // Rimuove tutto tranne i numeri
        return input.replace(/[^0-9]/g, "");
    } else if (type === "name") {
        // Rimuove tutto tranne le lettere accettate e gli spazi, poi controlla se cont
        let sanitizedName = input.split("").filter(char => acceptedLetters.includes(char.toLowerCase())).join("");
        // Controlla se contiene parole vietate
        if (containsBannedWords(sanitizedName)) {
            console.warn("Input contains banned words, clearing input.");
            return ""; // Se contiene parole vietate, restituisce una stringa vuota
        }

        return sanitizedName;
    }
    return input;
}

function containsBannedWords(input) {
    const lowerCaseInput = input.toLowerCase();
    return bannedWords.some(word => lowerCaseInput.includes(word));
}

function replaceLabelConfigurator() {
    const customizationLabel = document.querySelector(".cstmfy_personalize_text .pplr-customization .pplrlabel");
    const patchLabel = document.querySelector(".cstmfy_personalize_text .pplr-patch .pplrlabel");
    const playerLabel = document.querySelector(".pplr-customization ._pplr_player");
    const playerLabel2 = document.querySelector(".cstmfy_personalize_text .pplr-player .pplrlabel");
    const customLabel = document.querySelector(".pplr-customization ._pplr_name-number");
    const nameLabel = document.querySelector(".cstmfy_personalize_text .pplr-name .pplrlabel");
    const numberLabel = document.querySelector(".cstmfy_personalize_text .pplr-number .pplrlabel");
    const shortsNumberLabel = document.querySelector(".pplr-customization ._pplr_shorts-number");

    if (customizationLabel) {
        customizationLabel.textContent = window.configuratorLabels.label_personalizzazione;
    }
    if (patchLabel) {
        patchLabel.textContent = window.configuratorLabels.label_patch;
    }
    if (playerLabel) {
        playerLabel.textContent = window.configuratorLabels.player;
    }
    if (playerLabel2) {
        playerLabel2.textContent = window.configuratorLabels.player;
    }
    if (customLabel) {
        customLabel.textContent = window.configuratorLabels.custom;
    }
    if (nameLabel) {
        nameLabel.textContent = window.configuratorLabels.name;
    }
    if (numberLabel) {
        numberLabel.textContent = window.configuratorLabels.number;
    }

    if (shortsNumberLabel != null) {
        shortsNumberLabel.textContent = window.configuratorLabels.number;
    }
}

function isConfigurableProduct() {
    const customizableProduct = document.querySelector("body.customizable_product");
    return customizableProduct != null;
}

function addConfigurableClassToAddToCartButton() {
    let addToCartButton = document.querySelector("product-form .buy-buttons button[type='submit']");
    const configubleClass = "p_a_t_c";
    if (addToCartButton) {
        if (!addToCartButton.classList.contains(configubleClass)) {
            addToCartButton.classList.add(configubleClass);
            console.log("button", addToCartButton);
            console.log("Added 'p_a_t_c' class to Add to Cart button.");

        } else {
            console.log("'p_a_t_c' class already exists on Add to Cart button.");
        }
    } else {
        console.warn("Add to Cart button not found.");
    }
}

function blockMiniatureClick() {
    // Trova tutte le miniature nel DOM
    const miniatures = document.querySelectorAll('.product-gallery__thumbnail');
    // Blocca i click sulle miniature
    miniatures.forEach(miniature => {
        miniature.style.pointerEvents = 'none';
        miniature.classList.add('blocked-miniature');
    });

    console.log('Miniature clicks blocked');
}

function unblockMiniatureClick() {
    // Trova tutte le miniature bloccate
    const blockedMiniatures = document.querySelectorAll('.blocked-miniature');

    // Sblocca i click sulle miniature
    blockedMiniatures.forEach(miniature => {
        miniature.style.pointerEvents = 'auto';
        miniature.classList.remove('blocked-miniature');
    });

    console.log('Miniature clicks unblocked');
}

function showPersonalizationDisclaimer() {
    const disclaimer = document.querySelector(".disclaimer-personalization");
    if (disclaimer) {
        disclaimer.classList.remove("hidden");
    } else {
        console.warn("Disclaimer element not found.");
    }
}
function hidePersonalizationDisclaimer() {
    const disclaimer = document.querySelector(".disclaimer-personalization");
    if (disclaimer) {
        disclaimer.classList.add("hidden");
    } else {
        console.warn("Disclaimer element not found.");
    }
}

function removeCustomizationAppStyles() {
    const personalizer = document.querySelector(".product-personalizer");
    console.log("Personalizer container:", personalizer);

    if (!personalizer) {
        console.warn("Personalizer container not found.");
        return;
    }

    const cleanButtonStyles = () => {
        const customizeButton = personalizer.querySelectorAll(".btn.pplr-c-button.pplr-btn.button.Button--secondary.ptc_button");
        if (customizeButton.length > 0) {
            customizeButton.forEach(button => {
                button.removeAttribute("style");
            });
        }
    };

    cleanButtonStyles();

    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.type === 'childList') {
                if (mutation.addedNodes.length > 0) {
                    cleanButtonStyles();
                }
            }
        });
    });

    observer.observe(personalizer, {
        childList: true,
        subtree: false,
        attributes: false,
        characterData: false
    });

}

export function readyOnce(selectors, fn) {
    var MutationObserver = window.MutationObserver || window.WebKitMutationObserver;

    // Normalizza in array
    var selectorArray = typeof selectors === 'string' ? [selectors] : selectors;

    // Controlla subito se uno degli elementi esiste già
    for (var i = 0; i < selectorArray.length; i++) {
        var element = document.querySelector(selectorArray[i]);
        if (element) {
            fn.call(element, element);
            return;
        }
    }

    // Altrimenti crea observer che si disconnette al primo elemento trovato
    var observer = new MutationObserver(function (mutations, obs) {
        for (var i = 0; i < selectorArray.length; i++) {
            var element = document.querySelector(selectorArray[i]);
            if (element) {
                fn.call(element, element);
                obs.disconnect();
                return;
            }
        }
    });

    observer.observe(document.documentElement, {
        childList: true,
        subtree: true
    });
}